import { defineTokens } from '@chakra-ui/react';

export const spacingTokens = defineTokens({
  spacing: {
    '0': {
      value: '0px',
    },
  },
});
